import { render, staticRenderFns } from "./Summary_Details.vue?vue&type=template&id=2112775d&scoped=true&"
import script from "./Summary_Details.vue?vue&type=script&lang=js&"
export * from "./Summary_Details.vue?vue&type=script&lang=js&"
import style0 from "./Summary_Details.vue?vue&type=style&index=0&id=2112775d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2112775d",
  null
  
)

export default component.exports